import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type MigrationCardState = {
  isOpened: boolean;
};

const initialState: MigrationCardState = {
  isOpened: false,
};

export const migrationCardSlice = createSlice({
  name: 'migrationCard',
  initialState,
  reducers: {
    setMigrationCardOpened: (state, action: PayloadAction<boolean>) => ({
      isOpened: action.payload,
    }),
  },
});

export const migrationCardActions = migrationCardSlice.actions;
